<template>
<div class="col-12 text-left">
  <app-nav-bar></app-nav-bar>
  <div class="main-content">
    <h3 class="align-left">
      <small class="text-muted">Discharge Port</small>
    </h3>
    <div class="dropdown-divider"></div><br />
    <app-modal :elements="modalElements" v-on:confirm="del"></app-modal>
    <app-data-search v-on:searching="search"></app-data-search>
    <button type="button" class="btn btn-outline-primary" @click="add">Add  <i class="far fa-file"></i></button>
    <button type="button" class="btn btn-outline-info" @click="edit">Edit <i class="far fa-edit"></i></button>
    <button type="button" class="btn btn-outline-danger" data-toggle="modal" :data-target="`#${modalElements.modalId}`">Delete <i class="far fa-trash-alt"></i></button>
    <!-- <button type="button" class="btn btn-outline-success" @click="preview">Preview <i class="fas fa-print"></i></button> -->
    <br /><br />
    <app-datatable :type="'view'" :elements="dtElements" :collections="dp" v-on:selectedRow="selectRow"></app-datatable>
    <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
  </div>
</div>
</template>

<script>
import api from '../services/api'
import { dischargePort } from '../models/dischargePort'
import AppDatatable from '../components/AppDatatable.vue'
import AppModal from '../components/AppModal.vue'
import AppDataPagination from '../components/AppDataPagination.vue'
import AppDataSearch from '../components/AppDataSearch.vue'
import AppNavBar from '../components/AppNavbar.vue'

export default {
    components: {
      AppDatatable, AppModal, AppDataPagination, AppDataSearch, AppNavBar
    },
    data() {
      return {
        dp: [dischargePort],
        dtElements: [
          {
            title: 'Discharge Port',
            column: 'name',
            type: 'text'
          },
          {
            title: 'Country Name',
            column: 'countryName',
            type: 'text'
          },
          {
            title: 'Created At',
            column: 'createdAt',
            type: 'date'
          },
          {
            title: 'Created By',
            column: 'createdBy',
            type: 'text'
          },
          {
            title: 'Updated At',
            column: 'updatedAt',
            type: 'date'
          },
          {
            title: 'Updated By',
            column: 'updatedBy',
            type: 'text'
          },
        ],
        modalElements: {
          modalId: 'discharge-port',
          title: 'Confirm',
          content: 'Are you sure to delete this data?',
          type: 'text-confirm'
        },
        selectedId: '',
        searchKey: '',
        pagination: {
          pageSize: 10,
          currentPage: 1
        }
      }
  },
  async created() {
    this.init()
  },
  methods: {
    async init() {
      const dpApi = api('discharge-port/partial')
      const query = {
        params: {
          searchKey: this.searchKey,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        }
      }
      this.dp = await dpApi.getWithQuery(query) 
    },
    add() {
      this.$router.push({ name: 'dischargePortDetail' })
    },
    edit() {
      if(this.selectedId !== '') {
        this.$router.push({
          name: 'dischargePortDetail',
          query: {
            id: this.selectedId
          }
        })
      }
    },
    preview() {
      // if(this.selectedId !== '') {
      //     this.$router.push({
      //         name: 'appPurchaseOrderPrint',
      //         query: {
      //             id: this.selectedId
      //         }
      //     })
      // }
    },
    async del() {
      if(this.selectedId !== '') {
        const dpApi = api('discharge-port')
        await dpApi.delete(this.selectedId)
        this.init()
      }
    },
    selectRow(id) {
      this.selectedId = id
    },
    changePage(payload) {
      this.pagination = payload
      this.init()
    },
    search(searchKey) {
      this.searchKey = searchKey
      this.init()
    }
  }
}
</script>